var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"UpdatedAt"},[_vm._v(" "+_vm._s(_vm.value.date)+" - "+_vm._s(_vm.value.time)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }